export enum TimerType {
    SLA = "SLA",
    Deadline = "Deadline",
    DueDate = "Due Date",
    Manual = "Manual"
}